import * as React from 'react';
import { formatMessageBundle } from '@unifocus/js-utils';
import messages from '../../../localized-messages';
import { CSSProperties, ReactNode } from 'react';
import { Button } from '../button';

/**
 * {@docCategory NavBar}
 */
export interface NavBarButtonProps {
   /**
    * Called when the back button is clicked.
    */
   onClick: () => void;

   /**
    * Sets a className.
    */
   className?: string;

   /**
    * Sets styles.
    */
   style?: CSSProperties;

   /**
    * The children.
    */
   children?: ReactNode;
}

export const NavBarButton = (props: NavBarButtonProps) => {
   return (
      <Button
         className={'uf-nav-bar-button'}
         type={'link'}
         size={'large'}
         onClick={props.onClick}
      >
         {props.children}
      </Button>
   );
};
